<template>
  <div>
    <ca-heading text="Autônomos" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onNew">Adicionar Autônomo</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-loader v-if="loading"></ca-loader>

        <ca-table v-else>
          <ca-tr slot="header">
            <ca-th>Nome</ca-th>
            <ca-th>CPF</ca-th>
            <ca-th>Categoria</ca-th>
            <ca-th></ca-th>
          </ca-tr>

          <ca-tr
            v-for="(selfEmployed, index) in selfEmployedList.content"
            :key="index"
            @click="onView(selfEmployed.id)">
            <ca-td>
              {{ selfEmployed.selfEmployedName }}
            </ca-td>
            <ca-td>
              {{ selfEmployed.cpf | caCpf }}
            </ca-td>
            <ca-td>
              {{ selfEmployed.category.description }}
            </ca-td>
            <ca-td>
              <ca-button
                size="small"
                class="ca-u-min-margin-right"
                @click.stop="onEdit(selfEmployed.id)">
                Editar
              </ca-button>
              <ca-button size="small" @click.stop="onDelete(selfEmployed.id)">
                Excluir
              </ca-button>
            </ca-td>
          </ca-tr>
        </ca-table>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col class="ca-u-text-center">
        <ca-pagination
          v-if="!loading && selfEmployedList.totalPages > 1"
          v-model="currentPage"
          :total-pages="selfEmployedList.totalPages"
          class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center" />
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { DELETE_TITLE, DELETE_MESSAGE } from './constants';
import {
  getSelfEmployedList, deleteSelfEmployed,
} from './selfEmployedService';

export default {
  name: 'SelfEmployedPage',
  data() {
    return {
      loading: false,
      selfEmployedList: null,
      currentPage: 0,
      totalPages: 0,
    };
  },
  watch: {
    currentPage() {
      this.setSelfEmployedList();
    },
  },
  created() {
    this.setSelfEmployedList();
  },
  methods: {
    async setSelfEmployedList() {
      this.loading = true;
      try {
        this.selfEmployedList = await getSelfEmployedList({
          page: this.currentPage,
        });
      } catch (e) {
        this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
      } finally {
        this.loading = false;
      }
    },
    onNew() {
      this.$router.push({ name: 'NewSelfEmployed' });
    },
    onView(id) {
      this.$router.push({ name: 'ViewSelfEmployed', params: { id } });
    },
    onEdit(id) {
      this.$router.push({ name: 'EditSelfEmployed', params: { id } });
    },
    onDelete(selfEmployedId) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        onConfirm: () => {
          deleteSelfEmployed(selfEmployedId)
            .then(() => {
              this.$toaster.success('Autônomo excluído com sucesso.');
              this.setSelfEmployedList();
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir o autônomo');
            });
        },
      });
    },
  },
};
</script>
